import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOperatorSchedules from '../reducers/operator-schedules.reducer';
import { getAllRawVehicles } from './vehicle.selectors';

export const getOperatorSchedulesState =
  createFeatureSelector<fromOperatorSchedules.State>(
    fromOperatorSchedules.operatorSchedulesFeatureKey,
  );
export const getOperatorSchedules = createSelector(
  getOperatorSchedulesState,
  fromOperatorSchedules.getOperatorSchedules,
);

export const getAvailableVehiclesRaw = createSelector(
  getOperatorSchedulesState,
  fromOperatorSchedules.getAvailableVehicles,
);
export const getAssignedVehiclesRaw = createSelector(
  getOperatorSchedulesState,
  fromOperatorSchedules.getAssignedVehicles,
);

export const getOperatorSchedulesLoading = createSelector(
  getOperatorSchedulesState,
  fromOperatorSchedules.getOperatorSchedulesLoading,
);

export const getAvailableVehicles = createSelector(
  getAllRawVehicles,
  getAvailableVehiclesRaw,
  (allVehicles, availableVehicles) => {
    return allVehicles.filter((vehicle) =>
      availableVehicles.includes(vehicle.id),
    );
  },
);

export const getAssignedVehicles = createSelector(
  getAllRawVehicles,
  getAssignedVehiclesRaw,
  (allVehicles, assignedVehicles) => {
    return allVehicles.filter((vehicle) =>
      assignedVehicles.includes(vehicle.id),
    );
  },
);
